class BdlQueridinhosCarousel extends HTMLElement {
  connectedCallback() {
    this.scroller = this.querySelector('[data-bdl-queridinhos-track]');
    this.prevBtn = this.querySelector('[data-bdl-queridinhos-prev]');
    this.nextBtn = this.querySelector('[data-bdl-queridinhos-next]');
    this.index = 0;
    this.swipeStartX = 0;
    this.swipeTracking = false;

    if (!this.scroller) return;

    this.prevBtn?.addEventListener('click', () => this.goBy(-1));
    this.nextBtn?.addEventListener('click', () => this.goBy(1));
    this.scroller.addEventListener('scroll', () => this.onScroll(), { passive: true });
    this.bindOneStepSwipe(this.scroller);
    this.resizeObserver = new ResizeObserver(() => {
      this.snapToIndex(this.index, 'auto');
      this.updateButtons();
    });
    this.resizeObserver.observe(this.scroller);

    this.snapToIndex(0, 'auto');
    this.updateButtons();
  }

  disconnectedCallback() {
    this.resizeObserver?.disconnect();
    window.clearTimeout(this.scrollTimer);
    this.unbindOneStepSwipe();
  }

  /** Mobile: um passo por gesto, igual às setas (goBy). */
  bindOneStepSwipe(el) {
    this._onSwipeDown = (event) => {
      if (event.pointerType === 'mouse') return;
      this.swipeTracking = true;
      this.swipeStartX = event.clientX;
    };
    this._onSwipeUp = (event) => {
      if (!this.swipeTracking) return;
      this.swipeTracking = false;
      if (event.pointerType === 'mouse') return;

      const dx = event.clientX - this.swipeStartX;
      const threshold = Math.min(56, Math.max(36, el.clientWidth * 0.12));
      if (dx <= -threshold) this.goBy(1);
      else if (dx >= threshold) this.goBy(-1);
      else this.snapToIndex(this.index);
    };
    this._onSwipeCancel = () => {
      this.swipeTracking = false;
    };

    el.addEventListener('pointerdown', this._onSwipeDown);
    el.addEventListener('pointerup', this._onSwipeUp);
    el.addEventListener('pointercancel', this._onSwipeCancel);
  }

  unbindOneStepSwipe() {
    if (!this.scroller) return;
    this.scroller.removeEventListener('pointerdown', this._onSwipeDown);
    this.scroller.removeEventListener('pointerup', this._onSwipeUp);
    this.scroller.removeEventListener('pointercancel', this._onSwipeCancel);
  }

  cards() {
    return Array.from(this.querySelectorAll('[data-bdl-queridinhos-card]'));
  }

  gap() {
    const track = this.scroller?.querySelector('.bdl-queridinhos__track');
    if (!track) return 0;
    const styles = getComputedStyle(track);
    return Number.parseFloat(styles.columnGap || styles.gap || '0') || 0;
  }

  visibleCount() {
    const cards = this.cards();
    if (!cards.length) return 1;
    const cardWidth = cards[0].getBoundingClientRect().width;
    const step = cardWidth + this.gap();
    if (step <= 0) return 1;
    return Math.max(1, Math.floor((this.scroller.clientWidth + this.gap() + 1) / step));
  }

  maxIndex() {
    const total = this.cards().length;
    const visible = this.visibleCount();
    return Math.max(0, total - visible);
  }

  cardScrollLeft(card) {
    const track = this.scroller.querySelector('.bdl-queridinhos__track');
    if (!track) return card.offsetLeft;
    return card.offsetLeft - track.offsetLeft;
  }

  goBy(direction) {
    const step = this.visibleCount();
    this.snapToIndex(this.index + direction * step);
  }

  snapToIndex(nextIndex, behavior = 'smooth') {
    const cards = this.cards();
    if (!cards.length) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) behavior = 'instant';

    this.index = Math.min(Math.max(0, nextIndex), this.maxIndex());
    const target = cards[this.index];
    const left = this.index === this.maxIndex()
      ? this.scroller.scrollWidth - this.scroller.clientWidth
      : this.cardScrollLeft(target);

    window.clearTimeout(this.scrollTimer);
    this.scroller.scrollTo({ left, behavior });
    this.updateButtons();
  }

  onScroll() {
    window.clearTimeout(this.scrollTimer);
    this.scrollTimer = window.setTimeout(() => {
      const cards = this.cards();
      if (!cards.length) return;

      const scrollLeft = this.scroller.scrollLeft;
      let closest = 0;
      let closestDist = Infinity;

      cards.forEach((card, i) => {
        const dist = Math.abs(this.cardScrollLeft(card) - scrollLeft);
        if (dist < closestDist) {
          closestDist = dist;
          closest = i;
        }
      });

      const atEnd = this.scroller.scrollWidth - this.scroller.clientWidth - scrollLeft <= 1;
      this.index = atEnd ? this.maxIndex() : Math.min(closest, this.maxIndex());
      this.updateButtons();
    }, 90);
  }

  updateButtons() {
    const max = this.maxIndex();
    const needsNav = max > 0;
    if (this.prevBtn) {
      this.prevBtn.disabled = this.index <= 0;
      this.prevBtn.hidden = !needsNav;
    }
    if (this.nextBtn) {
      this.nextBtn.disabled = this.index >= max;
      this.nextBtn.hidden = !needsNav;
    }
  }
}

if (!customElements.get('bdl-queridinhos-carousel')) {
  customElements.define('bdl-queridinhos-carousel', BdlQueridinhosCarousel);
}
